import { createFileRoute } from '@tanstack/react-router'
import { ProjectWorkspacePage } from '../../../../features/projects/workspace-page'

export const Route = createFileRoute('/_app/projects/$projectId/')({
  component: ProjectWorkspacePage,
})
